// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Libraries
import { MatDialogRef } from '@angular/material/dialog';

// Models
import { AppCleanup } from '../../shared/models';

@Component({
	selector: 'add-location-dialog',
	templateUrl: './add-location-dialog.component.html',
	styleUrls: ['./add-location-dialog.component.scss'],
})
export class AddLocationDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	form: FormGroup;

	constructor(
		private formBuilder: FormBuilder,
		private dialogRef: MatDialogRef<AddLocationDialogComponent>
	) {
		super();
	}

	ngOnInit() {
		this.form = this.formBuilder.group({
			locationName: [null, [Validators.required, Validators.maxLength(50)]],
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	submit() {
		this.dialogRef.close(this.form.controls.locationName.value);
	}
}
